var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80957 8.40147C7.15717 8.06063 7.72087 8.06063 8.06853 8.40147L10.9999 11.2754L19.8661 2.58301C20.2138 2.24217 20.7774 2.24217 21.1251 2.58301C21.4727 2.92385 21.4727 3.47644 21.1251 3.81728L11.6294 13.1268C11.2818 13.4677 10.7181 13.4677 10.3705 13.1268L6.80957 9.63575C6.46191 9.29491 6.46191 8.74231 6.80957 8.40147Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9992 1.74553C6.24653 1.74553 2.39373 5.52282 2.39373 10.1823C2.39373 14.8418 6.24653 18.619 10.9992 18.619C15.7519 18.619 19.6047 14.8418 19.6047 10.1823C19.6047 9.70026 20.0032 9.30954 20.4949 9.30954C20.9866 9.30954 21.3852 9.70026 21.3852 10.1823C21.3852 15.8058 16.7352 20.3646 10.9992 20.3646C5.26321 20.3646 0.613281 15.8058 0.613281 10.1823C0.613281 4.55878 5.26321 0 10.9992 0C12.2274 0 13.4076 0.209381 14.5036 0.594448C14.9664 0.757065 15.2072 1.25673 15.0413 1.71051C14.8755 2.16424 14.3658 2.40024 13.903 2.23764C12.997 1.91931 12.0198 1.74553 10.9992 1.74553Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkCircle);
export default __webpack_public_path__ + "static/media/CheckMarkCircle.2e4011a66ed849b8911277f6da59a856.svg";
export { ForwardRef as ReactComponent };